import type { CacheConfig, RequestParameters, Variables } from "relay-runtime";

export const AUTH_TOKEN_KEY = "authToken";

export function getAuthToken() {
  return localStorage.getItem(AUTH_TOKEN_KEY);
}

export function setAuthToken(token: string) {
  localStorage.setItem(AUTH_TOKEN_KEY, token);
}

export function clearAuthToken() {
  localStorage.removeItem(AUTH_TOKEN_KEY);
}

// The onboarding design lab renders the real step components against fixtures,
// and those components commit their own mutations. Nothing a designer clicks in
// a preview should reach a database, so the lab installs a stub and mutations
// are answered from it instead of going out. The stub returns the payload for
// an operation by name — which is also how the lab reaches the states a step
// only enters on a particular server answer, like a rejected email address.
let mutationStub: ((operationName: string) => unknown) | null = null;

export function stubMutations(stub: ((operationName: string) => unknown) | null) {
  mutationStub = stub;
}

export async function fetchRelay(
  params: RequestParameters,
  variables: Variables,
  _cacheConfig: CacheConfig
) {
  if (mutationStub && params.operationKind === "mutation") {
    return { data: mutationStub(params.name) ?? {} };
  }

  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };

  const token = getAuthToken();
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  // Relative URL: vite proxies /graphql to Rails in dev; same-origin in prod.
  const response = await fetch("/graphql", {
    method: "POST",
    headers,
    body: JSON.stringify({
      query: params.text,
      variables,
    }),
  });

  if (response.status === 401) {
    clearAuthToken();
    if (window.location.pathname !== "/login") {
      window.location.assign("/login");
    }
    throw new Error("Unauthenticated");
  }

  const json = await response.json();

  if (Array.isArray(json.errors)) {
    throw new Error(
      `Error fetching GraphQL query '${
        params.name
      }' with variables '${JSON.stringify(variables)}': ${JSON.stringify(
        json.errors
      )}`
    );
  }

  return json;
}
